import {Component, Input, OnInit} from '@angular/core';
import {PlatformService} from 'src/app/app-common/services/native/platform.service';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';

enum HeadlessPage {
  Account = 'Account',
  Group = 'Group',
  Category = 'Category',
  Customer = 'Contact',
  Communication = 'Communication',
  Job = 'Job',
  Docs = 'Docs',
  Appointment = 'Appointment',
  Snippet = 'Snippet',
}

@Component({
  selector: 'app-headless-page',
  templateUrl: './headless-page.component.html',
  styleUrls: ['./headless-page.component.scss']
})
export class HeadlessPageComponent implements OnInit {
  @Input() title = '';
  @Input() icon = '';

  @Input() finisedLoading: boolean = true;

  get isElectron(): boolean {
    return this.platformService.isElectronApp;
  }

  constructor(private platformService: PlatformService,
              private appStateService: AppStateService) {
    this.appStateService.appWindowState = AppWindowState.Headless;
  }

  ngOnInit(): void {
  }
}
